import { render, staticRenderFns } from "./AddWorker.vue?vue&type=template&id=0270445c"
import script from "./AddWorker.vue?vue&type=script&lang=js"
export * from "./AddWorker.vue?vue&type=script&lang=js"
import style0 from "./AddWorker.vue?vue&type=style&index=0&id=0270445c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports